import React from "react";

/**
 * Minimal luxury stats band — flat solid blush background, no shadow / card / border.
 * Compact ~130-150px desktop height. 4-up desktop with subtle vertical dividers,
 * 2x2 on mobile. Numbers in serif rose, labels in uppercase deep brown.
 */
export default function StatsCard({ stats = [] }) {
  return (
    <section
      data-testid="stats-card-section"
      className="relative w-full bg-[#F8ECE9]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-8 md:py-7">
        <div
          className="grid grid-cols-2 md:grid-cols-4 md:divide-x"
          style={{ borderColor: "rgba(182, 89, 128, 0.16)" }}
          data-testid="stats-card"
        >
          {stats.map((s, i) => (
            <div
              key={s.label}
              className="px-3 sm:px-5 md:px-7 py-4 md:py-3 text-center flex flex-col justify-center"
              style={{ borderColor: "rgba(182, 89, 128, 0.16)" }}
              data-testid={`stat-item-${i}`}
            >
              <div
                className="font-display text-[36px] sm:text-[40px] md:text-[44px] leading-[1.05] text-[#B65980]"
                style={{ letterSpacing: "-0.01em" }}
              >
                {s.number}
              </div>
              <div className="mt-1.5 md:mt-2 text-[10.5px] sm:text-[11px] tracking-[0.16em] uppercase font-semibold text-[#3A2B25]/85">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
